declare const __COMPETENCEO_BUILD_ID__: string;

export const competenceoBuildId = __COMPETENCEO_BUILD_ID__;

export function shortBuildId(value = competenceoBuildId) {
  const date = new Date(value);
  return Number.isFinite(date.getTime())
    ? date.toLocaleString("fr-FR", {
        day:"2-digit",
        month:"2-digit",
        hour:"2-digit",
        minute:"2-digit",
      })
    : value;
}
